<template>
   <v-dialog
   v-model="openDialog"
    max-width="500px"
  >
    <v-card>
      <v-card-title class="title-card">
        <span class="text-h5">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form
            ref="form"
            v-model="valid"
          >
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-model="obj.nome"
                required
                :rules="nameRules"
                label="Nome"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-model="obj.descricao"
                :rules="nameRules"
                label="Descrição"
                required
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-model="obj.art"
                :rules="nameRules"
                label="Número de ART"
                required
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
         </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="closeModal"
        >
          Cancelar
        </v-btn>
        <v-btn
          dark
          color="primary"
          @click="save"
        >
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  props:{
        openDialog: Boolean
    },
    data () {
        return {
            valid:false,
            formTitle:'Novo cadastro',
            nameRules: [
              v => !!v || 'Campo requerido',
            ],
            dialog: false,
            obj: {
                descricao: '',
                nome:'',
                art:'',
            },
        }
    },
    methods: {
      ...mapActions('obra', ['saveObra']),
      async save() {
            this.$refs.form.validate()
            /* eslint-disable no-console */
            if (this.valid) {
                try {
                    await this.saveObra(this.obj)
                } catch (error) {
                    console.error(error);
                } finally {
                    this.closeModal();
                }
            }
        },
        closeModal () {
            this.$emit('closeModal')
        },
        reset(){
            this.$refs.form.reset()
        },
    watch:{
      openDialog(){
          this.reset();
      }
    },
    computed: {
        ...mapGetters('disciplina', {getDisciplines:'getList'}),
        ...mapGetters('curso', ['getList']),
    },
        
  }
}
</script>